export default __webpack_public_path__ + "static/media/tick2.da9161c3.svg";